// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"159":"dce15df8","296":"90f4b93a","797":"f5736f65","961":"81c3b9fa"}[chunkId] + ".css";
};